import '@/styles/ctags.css';
import "./style.css";

import TagBlock from '@/components/Tags/TagBlock.vue';
import {catchhandler, get} from '@geekjob/lib/http';
import data from '@/components/Tags/data';

//
var $serp = $('#serplist'),
	$paginator = $('#paginator'),
	$showmorebtn = $('#showmorebtn'),
	$upbtn = $('#upbtn'),
	$serpprogressbar = $('#serpprogressbar'),
	endmsg =
`63% наших кандидатов ищут работу анонимно, не афишируя свое резюме.<br>
<a class="link blue-text text-darken-1" href="//hr.${document.domain}/vacancy/edit">Разместите вакансию</a>,
которая сможет привлечь их`
;

$serpprogressbar.showBar = function () {
	clearTimeout(this.__timer);
	this.__timer = setTimeout(() => this.hide(), 1e4);
	this.show()
};
$serpprogressbar.hideBar = function () {
	clearTimeout(this.__timer);
	this.hide();
};

function scrollToSerp() {
	$('html, body').animate({scrollTop: $('#serpanchor').offset().top}, 'slow')
}

//
export default {
	components: {TagBlock},
	//
	data() {
		return {
			query: '',
			extfilters1: true,
			extfilters2: false,
			data: data.tree,
			selectedFindInputTags: [],
			selectedInputTags: [],
			anonim: false,
			loading: false,
			onlysales: false,
			inhouse: false,
			parttime: false,
			relocate: false,
			remote: false,
			nextpage: 1,
			showmorebtn: null,
			documentsCount: 0,
			sortby: 0
		};
	},
	//
	created() {
		$showmorebtn.click(() => {
			this.sendForm()
		});
		setTimeout(() => {
			$upbtn.show()
		}, 3e3);

		let selectedFiltersA = [],
			//selectedFiltersB = [],
			selectedFiltersC = ''
		;

		try {
			let h = new URLSearchParams(window.location.hash.substr(1));
			let q = window.location.searchParams;
			let f = s => h.get(s) || q.get(s);

			if (f('t')) selectedFiltersA = f('t').split(',').map(x => parseInt(x));
			if (f('qs')) selectedFiltersC = f('qs');
			//if (f('f')) selectedFiltersB = q.get('f').split(',').map(x => parseInt(x));
			if (f('f')) selectedFiltersB = f('f').split(',').map(x => parseInt(x));

			if (f('s')) this.onlysales = true;
			if (f('pt')) this.parttime = true;
			if (f('rl')) this.relocate = true;
			if (f('ih')) this.inhouse = true;
			if (f('rm')) this.remote = true;
			if (f('an')) this.anonim = true;
		} catch (e) {
			console.error(e)
		}

		switch (true) {
			case this.remote:
			case this.onlysales:
			case this.parttime:
			case this.inhouse:
			case this.relocate:
			case this.anonim:
				this.extfilters1 = true;
				break;
		}

		if (selectedFiltersA && selectedFiltersA.length) {
			this.selectedInputTags = selectedFiltersA;
			this.extfilters1 = true;
			this.extfilters2 = true;
		}
		// if (selectedFiltersB && selectedFiltersB.length) {
		//     this.extfilters1 = true;
		//     this.selectedFindInputTags = selectedFiltersB;
		// }
		if (selectedFiltersC && selectedFiltersC.length) {
			//this.extfilters1 = false;
			this.extfilters2 = false;
			this.query = selectedFiltersC;
		}
	},
	//
	mounted() {
		M.updateTextFields();
		if (this.query.length) {
			this.sendForm(1);
			if (this.onlysales || this.parttime || this.inhouse || this.remote || this.relocate || this.anonim) {
				this.extfilters1 = true
			}
		} else if (this.selectedInputTags.length || this.selectedFindInputTags.length) {
			this.extfilters1 = true;
			this.extfilters2 = true;
			this.sendForm(1)
		}
	},
	//
	updated() {
		M.updateTextFields()
	},
	//
	methods: {
		//
		changeURI(url, search) {
			history.pushState(search, 'Кандидаты ' + search.join(' '), url);
		},
		//
		clearForm() {
			//this.selectedFindInputTags = [];
			this.selectedInputTags = [];
			// window.location.hash = '';
			// window.location.search = '';
			// window.location.reload();
			location = '/geeks'
		},
		//
		sendForm(newreq = false) {
			$serpprogressbar.showBar();
			$paginator.html('Загрузка данных...');
			if (newreq) {
				this.nextpage = 1;
				this.documentsCount = 0;
				//location.hash = '#serp';
				$showmorebtn.show();
			}
			//
			let search = [];
			if (this.onlysales) search.push('s=1');
			if (this.parttime) search.push('pt=1');
			if (this.inhouse) search.push('ih=1');
			if (this.remote) search.push('rm=1');
			if (this.relocate) search.push('rl=1');
			if (this.anonim) search.push('an=1');
			if (this.sortby) search.push(`sort=${this.sortby}`);
			//
			if (this.query) {
				search.push('qs=' + encodeURIComponent(this.query));
				if (this.selectedInputTags && this.selectedInputTags.length) {
					search.push('t=' + this.selectedInputTags.join(','))
				}
			} else {
				if (this.$refs.tagBlock) {
					let a = this.$refs.tagBlock.getAllSelectedTags();
					if (a.length) search.push('t=' + a.join(','))
				}
				// if (this.selectedFindInputTags && this.selectedFindInputTags.length) {
				//     search.push('f=' + this.selectedFindInputTags.join(','))
				// }
			}

			//
			if (this.nextpage < 1) {
				this.noMoreSearchData();
				return
			}
			//
			if (newreq) {
				//window.location.hash = '#' + search.join('&');
				this.changeURI('/geeks?' + search.join('&'), search);
				scrollToSerp();
			}
			//
			let catchHandler = catchhandler.bind(this);

			get
				.call(this, '/json/find/geek?page=' + this.nextpage + '&' + search.join('&'), true)
				.then(res => {
					$paginator.html('');
					//
					if (res.error || (res.data.length < 1)) {
						$serp[res.error ? 'html' : 'append'](
							`<li class="collection-item center-align">По такому запросу мы не нашли удовлетворяющих результатов. Но... <br>${endmsg}</li>`
						);
						$showmorebtn.hide();
						$serpprogressbar.hideBar();
						this.documentsCount = 0;
						if (res.error) catchHandler(res.error);
						return;
					}
					//
					res.nextpage = parseInt(res.nextpage);
					this.nextpage = res.nextpage;
					this.documentsCount = res.documentsCount;
					//
					if (res.page == 1) $serp.html('');
					if (this.nextpage < 1) this.noMoreSearchData();
					//
					let htmls = '';
					for (let cv of res.data) {
						htmls += `
<li class="collection-item avatar">
	<div class="info">${[cv.city, cv.country].filter(x => x).join(', ')}<br><span class="salary">${cv.salary}</span></div>
	<div class="geek-list-logo ${cv.public ? 'public' : 'private'}">${cv.positionDesired.substr(0, 2).toUpperCase()}</div>
	<p class="truncate geek-title">
		<a href="/geek/${cv.id}" target="_blank" class="title truncate">${cv.positionDesired}</a>
	</p>
	<p class="truncate datetime-info">${(cv.file ? '🄵 ' : '') + cv.log.modify}</p>
	<div class="info">${

							(cv.jobFormat.relocate ? '<span class="relocate-label">relocate</span>&nbsp;' : '') +
							(cv.jobFormat.remote ? '<span class="remote-label">remote</span>&nbsp;' : '') +
							(cv.jobFormat.parttime ? '<span class="parttime-label">parttime</span>&nbsp;' : '') +
							(cv.jobFormat.inhouse ? '<span class="inhouse-label">office</span>&nbsp;' : '')

						}</div>
</li>`;
					}

					$serp.append(htmls);
					setTimeout(function () {
						$serpprogressbar.hideBar()
					}, 1e3);
				})
				.catch(catchHandler)
			;
		},
		//
		noMoreSearchData() {
			$paginator.html(`<p class="center-align">${endmsg}</p>`);
			$showmorebtn.hide();
			$serpprogressbar.hideBar();
		},
		//
		showFilters() {
			this.extfilters1 = true;
		},
		showSubFilters() {
			this.extfilters2 = true;
			this.query = '';
		},
		hideFilters() {
			this.extfilters1 = false;
			this.extfilters2 = false;
			setTimeout(() => {
				this.$refs.queryinput.focus()
			}, 0);
		},
		hideSubFilters() {
			this.extfilters2 = false;
			setTimeout(() => {
				this.$refs.queryinput.focus()
			}, 0);
		},
		clearQueryInput() {
			this.query = '';
			this.changeURI('/geeks', ['IT', '&', 'Digital']);
		},
		quickFind(qs) {
			this.query = qs;
			this.sendForm(true);
		}
	},
	computed: {
		queryLength() {
			return this.query.length > 0
		}
	}
};
